export default __webpack_public_path__ + "static/media/profileSidebarIcon_setting.5cf47694.svg";